import {useDispatch} from 'react-redux';
import {SET_LANGUAGE, SET_RELOAD} from '../actions';
import {setupLocale} from '../i18n';

export function useSetLocale() {
  const dispatch = useDispatch();
  return (locale, catalogs) => {
    setupLocale(locale, catalogs);
    dispatch({type: SET_LANGUAGE, payload: locale});
    dispatch({type: SET_RELOAD, payload: true});
    setTimeout(() => {
      dispatch({type: SET_RELOAD, payload: false});
    });
  };
}
